export const AZM_SIDEBAR_INLINE_MIN_WIDTH = 1200;

export const AZM_SIDEBAR_OVERLAY_MAX_WIDTH = AZM_SIDEBAR_INLINE_MIN_WIDTH - 0.02;

export const AZM_ADMIN_SIDEBAR_OVERLAY_MAX_WIDTH = 1300;

export function isSidebarInlineViewport(width: number): boolean {
	return width >= AZM_SIDEBAR_INLINE_MIN_WIDTH;
}
